
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/presentation",
      function () {
        return require("private-next-pages/blog/presentation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/presentation"])
      });
    }
  